import store from "@/store";

const mixin = {
  methods: {
    formatEventName(name, edition) {
      return name + "'" + edition.substring(2);
    },
    formatEventUrl(name, edition) {
      return (
        "/event/" +
        (name.replace(/ /g, "") + edition.substring(2)).toLowerCase()
      );
    },
    entityUrl(entity_name, id, event_id) {
      var event = store.getters.isEventSelected
        ? store.getters["events/getCurrentEvent"]()
        : event_id
        ? store.getters["events/getEventByID"](event_id)
        : false;
      var path = event ? this.formatEventUrl(event.name, event.edition) : "";
      switch (entity_name) {
        case "club":
          path += "/club";
          break;
        case "team":
          path += "/team";
          break;
        case "person":
          path += "/person";
          break;
        case "participant":
          path += "/participants";
          break;
      }
      path += "/card/" + id;

      return path;
    },
    fnGoToTeamZones(entity) {
      if ([1, 2, 3].includes(entity)) {
        window.open(
          process.env.VUE_APP_TEAMZONE_URL +
            "viewmic/" +
            this.$route.params.event +
            "/" +
            entity +
            "/" +
            this.$route.params.id +
            "?token=" +
            localStorage.token,
          "_blank"
        );
      } else if (entity == 30) {
        window.open(
          process.env.VUE_APP_VOLUNTEER_URL +
            "viewmic/" +
            this.$route.params.id +
            "?token=" +
            localStorage.token,
          "_blank"
        );
      }
    }
  }
};

export default mixin;
